import { createFileRoute } from '@tanstack/react-router';
import { MediaAssetsPage } from '@pages/media-assets';

/** Asset-Bibliothek-Route (/media/assets) */
export const Route = createFileRoute('/_authenticated/media/assets')({
  component: MediaAssetsPage,
});
